import { createHttpService } from "../ApiService";
import type {
  TGetConfigResponse,
  TGetTemplatesResponse,
  TUpdateConfigRequest,
  TUpdateConfigResponse,
} from "./reportCard.interfaces";
import {
  getReportCardConfigMock,
  getReportCardTemplatesMock,
  updateReportCardConfigMock,
} from "../../__mocks__/reportCard/reportCardMock";

export const useReportCardService = () => {
  const httpAPI = createHttpService();
  const appWithMockData = import.meta.env.VITE_APP_WITH_MOCK_DATA === "true";

  const getTemplates = () => {
    if (appWithMockData) {
      return Promise.resolve(getReportCardTemplatesMock());
    }
    return httpAPI.reportCard.get<TGetTemplatesResponse>("/templates");
  };

  const getConfig = () => {
    if (appWithMockData) {
      return Promise.resolve(getReportCardConfigMock());
    }
    return httpAPI.reportCard.get<TGetConfigResponse>("/config");
  };

  const updateConfig = (request: TUpdateConfigRequest) => {
    if (appWithMockData) {
      return Promise.resolve(updateReportCardConfigMock(request));
    }
    return httpAPI.reportCard.put<TUpdateConfigResponse>("/config", request);
  };

  return { getTemplates, getConfig, updateConfig };
};
